import React, { useState, useEffect } from "react";

import "./App.css";

import placeholder2 from "./images/placeholder2.png";
import flagTR from "./images/flag-tr.svg";
import flagEN from "./images/flag-en.svg";
import FeatureCard from "./components/FeatureCard";
import image01 from "./images/image-01.png";
import image02 from "./images/image-02.png";
import image03 from "./images/image-03.png";
import image04 from "./images/image-04.png";
import image05 from "./images/image-05.png";
import image06 from "./images/image-06.jpg";
import image07 from "./images/image-07.png";
import imageHead from "./images/image-macbook.jpg";

import pdfCV from "./files/Okan_Yucel_CV.pdf";

import ContentCard from "./components/ContentCard";
import ButtonModal from "./components/ButtonModal";
import AlertModal from "./components/AlertModal";
import { v4 as uniqueKey } from "uuid";

import { Trans, useTranslation } from "react-i18next";
import Language from "./components/Language";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";

function App({}) {
  const { t, i18n } = useTranslation("language");

  const [language, setLanguage] = useState("en");

  const [menu, setMenu] = useState(false);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  const changeLanguage = () => {
    language === "en" ? setLanguage("tr") : setLanguage("en");
  };

  const [playAnimation, setPlayAnimation] = useState(false);
  // This will run one time after the component mounts
  useEffect(() => {
    const onPageLoad = () => {
      setPlayAnimation(true);
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);

  return (
    <>
      <Modal
        show={menu}
        onHide={() => {
          setMenu(false);
        }}
        animation={false}
        className=""
        contentClassName="rounded-xxl bg-white text-dark modal-content-custom"
      >
        <div className="rounded-xxl bg-white text-dark shadow-blue">
          <a
            className="d-flex flex-row gap-3 justify-content-start align-items-center px-3 py-1 hoverable rounded-xxl"
            onClick={() => {
              menu ? setMenu(false) : setMenu(true);
              document
                .querySelector("#welcome")
                .scrollIntoView({ block: "center" });
            }}
          >
            <div>
              <i className="item-icon fs-5 mdi mdi-human-greeting-variant text-blue"></i>
            </div>
            <div className="text-dark me-2">
              <Language language={language} text="welcome" />
            </div>
          </a>
          <a
            className="d-flex flex-row gap-3 justify-content-start align-items-center px-3 py-1 hoverable rounded-xxl"
            onClick={() => {
              menu ? setMenu(false) : setMenu(true);
              document.querySelector("#cv").scrollIntoView({ block: "center" });
            }}
          >
            <div>
              <i className="item-icon fs-5 mdi mdi-certificate text-blue"></i>
            </div>
            <div className="text-dark me-2">
              <Language language={language} text="cv" />
            </div>
          </a>
          <a
            className="d-flex flex-row gap-3 justify-content-start align-items-center px-3 py-1 hoverable rounded-xxl"
            onClick={() => {
              menu ? setMenu(false) : setMenu(true);
              document
                .querySelector("#contact")
                .scrollIntoView({ block: "center" });
            }}
          >
            <div>
              <i className="item-icon fs-5 mdi mdi-card-account-phone text-blue"></i>
            </div>
            <div className="text-dark me-2">
              <Language language={language} text="contact" />
            </div>
          </a>
        </div>
      </Modal>
      <div className={`${playAnimation ? "anim-show" : "anim-hide"}`}>
        <div
          className="position-fixed top-0 start-0 w-100"
          style={{ zIndex: "10" }}
        >
          <div className="position-sticky m-auto">
            <div className="bg-blur-xl shadow-sm">
              <div className="col-12 col-sm-7 col-md-6 col-lg-5 col-xl-4 d-flex flex-row justify-content-between align-items-center m-auto py-1 px-3">
                <div className="col text-dark">
                  <Dropdown>
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      className="btn-main bg-white border-light shadow-blue rounded-xxl d-flex align-items-center gap-2 w-fit hoverable py-0"
                    >
                      <i className="item-icon uil-bars fs-5 py-1 text-blue"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="rounded-xxl border-none mt-2 p-3 dropdown-main">
                      <div className="d-flex flex-column gap-2">
                        <a
                          className="d-flex flex-row gap-3 justify-content-start align-items-center px-3 py-1 btn-main bg-blue text-white"
                          onClick={() => {
                            document
                              .querySelector("#welcome")
                              .scrollIntoView({ block: "center" });
                          }}
                        >
                          <div>
                            <i className="item-icon-dark fs-5 mdi mdi-human-greeting-variant"></i>
                          </div>
                          <div className="text-white me-2 pe-3">
                            <div className="pe-3">
                              <Language language={language} text="welcome" />
                            </div>
                          </div>
                        </a>
                        <a
                          className="d-flex flex-row gap-3 justify-content-start align-items-center px-3 py-1 btn-main bg-blue text-white"
                          onClick={() => {
                            document
                              .querySelector("#contact")
                              .scrollIntoView({ block: "center" });
                          }}
                        >
                          <div>
                            <i className="item-icon-dark fs-5 mdi mdi-card-account-phone text-white"></i>
                          </div>
                          <div className="text-white me-2 pe-3">
                            <div className="pe-3">
                              <Language language={language} text="contact" />
                            </div>
                          </div>
                        </a>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="col d-flex justify-content-end">
                  <div className="d-flex gap-1 py-1 align-items-center">
                    <a
                      // onClick={() => changeLanguage()}
                      className={`shadow-none ${
                        language != "en"
                          ? "filter-disable-on"
                          : "filter-disable-off"
                      }`}
                    >
                      <img
                        src={flagEN}
                        style={{
                          width: "30px",
                          height: "30px",
                          objectFit: "cover",
                        }}
                        className="rounded-xxl overflow-hidden bg-white shadow-sm hoverable p-1"
                      />
                    </a>
                    <a
                      disabled
                      // onClick={() => changeLanguage()}
                      className={`shadow-none ${
                        language != "tr"
                          ? "filter-disable-on"
                          : "filter-disable-off"
                      }`}
                    >
                      <img
                        src={flagTR}
                        style={{
                          width: "30px",
                          height: "30px",
                          objectFit: "cover",
                          objectPosition: "25%",
                        }}
                        className="rounded-xxl overflow-hidden bg-white shadow-sm hoverable p-1"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="position-fixed top-5 start-0" style={{ zIndex: "-1" }}>
          <img
            className=""
            src={imageHead}
            style={{
              width: "100vw",
              height: "100vh",
              overflow: "auto",
              objectFit: "cover",
              backgroundSize: "cover",
            }}
          />
        </div>
        <div
          className="col-12 col-sm-7 col-md-6 col-lg-5 col-xl-4 m-auto d-flex flex-column justify-content-center gap-3 px-3"
          style={{ paddingTop: "60px" }}
        >
          <div
            id="welcome"
            name="welcome"
            className="card-main col-12 bg-white p-3 d-flex flex-column gap-3"
          >
            <div className="text-start">
              <h3 className="text-dark m-0 mb-3 d-flex align-items-center">
                <i className="item-icon mdi mdi-human-greeting-variant fs-1 me-2 text-blue"></i>{" "}
                <span className="mt-1 ms-2">
                  <Language language={language} text="welcome message" />
                </span>
              </h3>

              <div className="d-flex flex-column gap-3">
                <div className="text-dark mx-3">
                  <div className="d-flex flex-column gap-3">
                    <div className="item d-flex flex-row gap-3">
                      <div className="d-flex align-items-top text-dark">
                        <i className="item-sub-icon mdi mdi-badge-account-horizontal fs-5"></i>
                      </div>
                      <div className="d-flex align-items-top mt-1">
                        <span className="text-dark fw-normal">
                          <Language language={language} text="who I am" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-column gap-3 justify-content-center">
              <ButtonModal
                language={language}
                key={uniqueKey()}
                classes="btn-main fw-bold bg-white"
                target="https://www.linkedin.com/in/oknycl"
                icon="mdi mdi-linkedin"
                iconClasses="text-blue fs-5 item-icon"
                textPrimary="LinkedIn"
              />
              <ButtonModal
                language={language}
                key={uniqueKey()}
                classes="btn-main fw-bold bg-white"
                target="https://www.behance.net/oknycl"
                icon="uil-behance"
                iconClasses="text-blue fs-5 item-icon"
                textPrimary="Behance"
              />
            </div>
          </div>

          <div
            id="contact"
            name="contact"
            className="card-main col-12 bg-white p-3 d-flex flex-column gap-3"
            style={{ marginBottom: "25vh" }}
          >
            <div className="content-header">
              <div className="text-start">
                <h3 className="text-dark m-0 mb-3 d-flex align-items-center">
                  <i className="item-icon mdi mdi-card-account-phone fs-1 me-2 text-blue"></i>{" "}
                  <span className="mt-1 ms-2">
                    <Language language={language} text="contact" />
                  </span>
                </h3>

                <div className="text-dark mx-3">
                  <div className="d-flex flex-column gap-3">
                    <div className="item d-flex flex-row gap-3">
                      <div className="d-flex align-items-top text-dark">
                        <i className="item-sub-icon mdi mdi-comment-quote fs-5"></i>
                      </div>
                      <div className="d-flex align-items-top mt-1">
                        <span>
                          <Language
                            language={language}
                            text="contact preference"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="content-body">
              <div className="d-flex flex-column gap-3">
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  target="oknycl@gmail.com"
                  icon="mdi mdi-google"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Gmail"
                  textColor="white"
                  clipboard="oknycl@gmail.com"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  target="https://www.linkedin.com/in/oknycl"
                  icon="mdi mdi-linkedin"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="LinkedIn"
                  textColor="white"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  target="https://t.me/oknycl"
                  icon="mdi mdi-send"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Telegram"
                  textColor="white"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  icon="mdi mdi-slack"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Slack"
                  textColor="white"
                  clipboard="@oknycl"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  target="https://github.com/oknycl"
                  icon="mdi mdi-github"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="GitHub"
                  textColor="white"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  target="https://gitlab.com/oknycl"
                  icon="mdi mdi-gitlab"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="GitLab"
                  textColor="white"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  target="https://t.me/oknycl"
                  icon="mdi mdi-discord"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Discord"
                  textColor="white"
                  clipboard="oky#7918"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  icon="mdi mdi-video"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Zoom"
                  textColor="white"
                  clipboard="oknycl@gmail.com"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  icon="mdi mdi-microsoft-teams"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Teams"
                  textColor="white"
                  clipboard="oknycl@gmail.com"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  icon="mdi mdi-skype"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Skype"
                  textColor="white"
                  clipboard="oknycl@gmail.com"
                />
                <ButtonModal
                  language={language}
                  key={uniqueKey()}
                  classes="btn-main fw-bold bg-white"
                  target="https://calendly.com/oknycl"
                  icon="mdi mdi-calendar"
                  iconClasses="text-blue fs-5 item-icon"
                  textPrimary="Calendly"
                  textColor="white"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
